import React from 'react';

const CartInventoryTable = props => {
    return(
        <div className="cart__event-content">
            <header className="cart__event-info">
                {props.header}
            </header>
            <main className="tickets-table">
                {props.body}
            </main>
        </div>
    )
}

export default CartInventoryTable;
